import React from 'react';
import { Modal, Descriptions, Tag, Badge, Button } from 'antd';
import {
  ExportOutlined,
  DownloadOutlined,
  DatabaseOutlined,
  TableOutlined,
} from '@ant-design/icons';
import styles from '../../styles/chatV2.module.css';

const SourceDetailModal = ({ visible, source, onClose }) => {
  if (!source) return null;

  const renderDatasetDetails = () => {
    if (source.sourceType !== 'RawDataset') return null;

    if (source.queryType === 'AGGREGATION') {
      return (
        <div className={styles.sourceDataset}>
          <h4>Aggregation Result</h4>
          <Descriptions bordered size="small" column={2}>
            <Descriptions.Item label="Type">
              {source.aggregationType}
            </Descriptions.Item>
            <Descriptions.Item label="Group By">
              {source.groupBy || 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Filtered Rows">
              {source.filteredRows?.toLocaleString()}
            </Descriptions.Item>
            <Descriptions.Item label="Total Rows">
              {source.totalRows?.toLocaleString()}
            </Descriptions.Item>
          </Descriptions>
        </div>
      );
    }

    return (
      <div className={styles.sourceDataset}>
        <h4>Dataset Information</h4>
        <Descriptions bordered size="small" column={2}>
          <Descriptions.Item label="Rows">
            {source.rowCount?.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label="Columns">
            {source.columns?.length || 0}
          </Descriptions.Item>
          <Descriptions.Item label="Total Rows" span={2}>
            {source.totalRows?.toLocaleString()}
          </Descriptions.Item>
        </Descriptions>

        {source.columns && (
          <div className={styles.columnList}>
            <h5>Columns:</h5>
            <div className={styles.columnTags}>
              {source.columns.map((col, i) => (
                <Tag key={i} icon={<TableOutlined />}>
                  {col}
                </Tag>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderHealthScore = () => {
    if (!source.healthScore) return null;

    let color = 'success';
    if (source.healthScore < 50) color = 'error';
    else if (source.healthScore < 75) color = 'warning';

    return (
      <Badge
        count={source.healthScore}
        showZero
        color={color}
        className={styles.healthBadge}
      />
    );
  };

  return (
    <Modal
      title={
        <div className={styles.sourceModalHeader}>
          <span>{source.title || 'Source Details'}</span>
          {renderHealthScore()}
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={700}
      footer={[
        <Button
          key="view"
          type="primary"
          icon={<ExportOutlined />}
          onClick={() => window.open(source.url, '_blank')}
        >
          View Source
        </Button>,
        <Button
          key="download"
          icon={<DownloadOutlined />}
          onClick={() => {
            /* Download logic */
          }}
        >
          Download
        </Button>,
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      <div className={styles.sourceModalContent}>
        {/* General Information */}
        <Descriptions bordered size="small" column={1}>
          <Descriptions.Item label="Type">
            <Tag color="blue">{source.sourceType}</Tag>
          </Descriptions.Item>

          {source.moduleName && (
            <Descriptions.Item label="Module">
              {source.moduleName}
            </Descriptions.Item>
          )}

          {source.reportName && (
            <Descriptions.Item label="Report">
              {source.reportName}
            </Descriptions.Item>
          )}

          {source.pageId && (
            <Descriptions.Item label="Page">{source.pageId}</Descriptions.Item>
          )}

          {source.date && (
            <Descriptions.Item label="Generated">
              {new Date(source.date).toLocaleString()}
            </Descriptions.Item>
          )}
        </Descriptions>

        {/* Excerpt */}
        {source.excerpt && (
          <div className={styles.sourceExcerpt}>
            <h4>Summary</h4>
            <p>{source.excerpt}</p>
          </div>
        )}

        {/* Dataset-specific details */}
        {renderDatasetDetails()}
      </div>
    </Modal>
  );
};

export default SourceDetailModal;
